module.exports = __webpack_public_path__ + "img/q_58_sor.d4823124.png";